import { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useI18n from "@/hooks/useI18n";

interface NavLanguageProvider extends PropsWithChildren {
	path?: string;
}

// This provider checks the url and the current cookies for authentication
export const NavLanguageProvider = ({
	path = "",
  children
}: NavLanguageProvider) => {
	const params = useParams();
	const [searchParams, _setSearchParams] = useSearchParams();
  const location = useLocation();
	const { t } = useTranslation();
  const { currentLang } = useI18n();
  const navigate = useNavigate();

  const getTranslatedPath = (withSearchParams?: boolean) => {
    return t(path.replace("{{", ":").replace("}}", ""), params) + 
      (withSearchParams ? ("?" + searchParams) : "")
  }

  const isLocationCorrect = () => {
    return path ? (getTranslatedPath() == location.pathname) : true
  }

  useEffect(() => {
    if (!isLocationCorrect) {
      navigate(getTranslatedPath(true), {replace: true});
    }
  }, [path, currentLang])

  return children;
}
